import React from 'react'
import TypoCss from "./typography.module.scss";



function Title({title, style = null}) {

  return <div style={style} className={TypoCss.card_title}>{title}</div>;
}

export default Title